export default "__VITE_ASSET__CtWsvEkd__"